export interface Settings {
  AUTH0_DOMAIN: string
  AUTH0_CLIENT_ID: string
  AUTH0_AUDIENCE: string
  ENVIRONMENT: string
  SENTRY_DSN: string
  REGION: string
}

const UNSET_VARIABLE_REGEX_STRING = '\\${([A-Z0-9_]*)}'

/**
 * DEFAULT SETTING IF IS NOT DEFINED ON config.js
 */
const DEF_SETTINGS: Settings = {
  AUTH0_DOMAIN: process.env.VITE_AUTH0_DOMAIN ?? '',
  AUTH0_CLIENT_ID: process.env.VITE_AUTH0_CLIENT_ID ?? '',
  AUTH0_AUDIENCE: process.env.VITE_AUTH0_AUDIENCE ?? '',
  ENVIRONMENT: process.env.VITE_ENVIRONMENT ?? '',
  SENTRY_DSN: process.env.VITE_SENTRY_DSN ?? '',
  REGION: process.env.VITE_REGION ?? '',
}

function getConfigValue(key: keyof Settings) {
  const value = window.__TSYL_CONFIG__[key]
  const isDefault = value === '' || new RegExp(UNSET_VARIABLE_REGEX_STRING, 'gm').test(value)
  if (isDefault) {
    return DEF_SETTINGS[key]
  } else {
    return value
  }
}

function buildSettings() {
  const entries = Object.entries(window.__TSYL_CONFIG__).map(([key]) => [
    key,
    getConfigValue(key as keyof Settings),
  ])
  return Object.freeze(Object.fromEntries(entries) as Settings)
}

export default buildSettings()
